module.exports = __webpack_public_path__ + "media/images/players/HORSFIELD_SAM-4c260245d7fcb8855c98d2be745d8e1a.png";